export default [{
  path: '/reasonType',
  name: 'reasonType',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/reasonType/index')
}]
